import { CssVariable, Visibility } from './libs.js';

const $ = jQuery;

$('#scroll-top').on('click', function(event) {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
});

const header = $('header.header');

$('#nav-mobile').on('click', function(event) {
    header.toggleClass('nav-opened');
});

$('.push-content-block').each(function() {
    const block = $(this);
    const offset = new CssVariable(this, 'block-offset', 'px');

    $(document).on('scroll', function(event) {
        const ypos = block.offset().top;
        const ytop = $(document).scrollTop();

        if (ytop > ypos) {
            offset.set(ytop - ypos);
        }
    });

    // v.on('viewport:enter', function(event) {
    //     offset.set(0);
    // });

    // v.on('viewport:leave', function(event) {
    //     offset.set(0);
    // });
});

const rootMarginBottom = $('.evin-disclaimer').height();

$('.pastis-51-block').each(function() {
    const block = $(this);

    const v = new Visibility(this, {
        rootMargin: `0px 0px ${rootMarginBottom}px 0px`,
        threshold: 0.2
    });

    v.on('viewport:enter', function(event) {
        block.addClass('block-visible');
    });

    // v.on('viewport:leave', function(event) {
    //     block.removeClass('block-visible');
    // });
})

$('.timeline-block .timeline-event').each(function() {
    const $event = $(this);

    const v = new Visibility(this, {
        rootMargin: `0px 0px ${rootMarginBottom}px 0px`,
        threshold: 0.1
    });

    v.on('viewport:enter', function(event) {
        $event.addClass('event-visible');
    });
})
